import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { SendPolicyDocumentsByEmailClientResponse } from '../@types/SendPolicyDocumentsByEmail'

type Store = {
  sendPolicyDocumentsByEmail: SendPolicyDocumentsByEmailClientResponse | null
  setSendPolicyDocumentsByEmail: (
    value: SendPolicyDocumentsByEmailClientResponse,
  ) => void
}

export const useSendPolicyDocumentsByEmailStore = create<Store>()(
  devtools(
    (set) => ({
      sendPolicyDocumentsByEmail: null,
      setSendPolicyDocumentsByEmail: (sendPolicyDocumentsByEmail) =>
        set({ sendPolicyDocumentsByEmail }),
    }),
    { name: 'SendPolicyDocumentsByEmailStore' },
  ),
)
